module.exports = __webpack_public_path__ + "img/adresse.934be3b0.png";